import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function SanctionsTable() {
  const sanciones = [
    { grado: 'Leve', rango: '45 - 2.450 €', descripcion: 'Incumplimientos formales menores', color: 'text-slate-600' },
    { grado: 'Grave (Art. 12.16 LPRL)', rango: '2.451 - 49.180 €', descripcion: 'Vigilancia insuficiente, falta de documentación', color: 'text-amber-500' },
    { grado: 'Muy Grave (Art. 13.8)', rango: '49.181 - 983.736 €', descripcion: 'Obstrucción, omisión de adaptaciones requeridas', color: 'text-rose-500' },
  ];

  return (
    <section className="bg-slate-950 text-white py-24 px-6" data-testid="sanctions-table">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-rose-500">
            Marco sancionador
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold tracking-tight mt-4">
            Tabla LISOS 2026
          </h2>
          <p className="mt-4 text-lg text-slate-400 max-w-2xl">
            Infracciones y sanciones actualizadas según la Ley de Infracciones y Sanciones en el Orden Social.
          </p>
        </div>

        <div className="overflow-hidden border border-slate-700">
          <table className="sanction-table" data-testid="sanctions-data">
            <thead>
              <tr>
                <th className="w-1/3">Grado de infracción</th>
                <th className="w-1/3">Sanción</th>
                <th className="w-1/3">Supuestos</th>
              </tr>
            </thead>
            <tbody>
              {sanciones.map((sancion) => (
                <tr key={sancion.grado}>
                  <td className={`font-semibold ${sancion.color}`}>
                    <div className="flex items-center gap-2">
                      {sancion.grado.includes('Muy Grave') && <AlertTriangle size={16} />}
                      {sancion.grado}
                    </div>
                  </td>
                  <td className={sancion.color}>{sancion.rango}</td>
                  <td className="text-slate-400">{sancion.descripcion}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 p-6 bg-slate-900/50 border border-slate-800">
          <p className="text-sm text-slate-400">
            <strong className="text-slate-300">Nota importante:</strong> La responsabilidad puede extenderse a Servicios de Prevención Ajenos (SPA), 
            Técnicos de Prevención y administradores de la empresa. Artículos 12.16 y 13.8 de la LPRL.
          </p>
        </div>
      </div>
    </section>
  );
}
